import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const yborCityConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Ybor City Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Ybor City, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_ybor_city',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Ybor City',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Ybor City Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide professional tree care in the 
     historic and vibrant neighborhood of <strong>Ybor City</strong>. This culturally 
     rich community blends historic structures with newer development and the trees 
     here grow in tight spaces between buildings, along brick lined streets, and over 
     properties that require careful, experienced handling. Our team knows how to work 
     precisely in complex urban environments.`,

    `We specialize in <strong>hazardous tree removal and trimming in dense historic 
     settings</strong> large limbs overhanging historic structures and commercial 
     properties, storm damaged trees in active pedestrian areas, root intrusion near 
     aging infrastructure, and canopy reduction that keeps trees healthy without 
     compromising the character of the neighborhood.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, expert tree care 
     throughout <strong>Ybor City</strong> and the surrounding 
     <strong>Tampa urban neighborhoods</strong> protecting your property and 
     the historic fabric of this unique community.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Ybor City, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_YborCity = () => <LocationPage config={yborCityConfig} />;
export default Services_YborCity;
